exports.LinkResolver = (doc) => {
  if (!doc) return null;

  if (doc.type === 'content') {
    return `/items/` + doc.uid
  }
  if (doc.type === 'subject' || doc.__typename === 'PrismicSubject' || doc.__typename === 'PrismicContentBodySubjects') {
    return `/` + doc.uid
  }
  if(doc.type === 'content_home'){
    return `/` + doc.uid
  }
  if(doc.type === 'content_category_landing_page'){
    return `/category/` + doc.uid
  }
  // Featured items route fallback
  return `/`;
}


